"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = void 0;
const react_1 = require("react");
const JourneyAppContext_1 = require("../contexts/JourneyAppContext");
function useAlert() {
    const { alert, setAlert } = react_1.useContext(JourneyAppContext_1.JourneyAppContext);
    return [alert, setAlert];
}
exports.useAlert = useAlert;
